import { CharacteristicObject } from './characteristic-object.model';

export class SingleCharacteristicObject extends CharacteristicObject {
    private _value: string;

    constructor(name: string, value: string, id: string) {
        super(name, id);
        this._value = value;
    }
    public get value(): string {
        return this._value;
    }
    public set value(value: string) {
        this._value = value;
    }
    public clone(): SingleCharacteristicObject {
        return new SingleCharacteristicObject(this.name, this.value, this.id);
    }
    public equals(other: SingleCharacteristicObject): boolean {
        if (this.value === other.value) {
            return true;
        } else {
            return false;
        }
    }

}
